var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('tr',[_c('td',{attrs:{"width":"44"}},[_c('v-avatar',{attrs:{"size":"32"}},[_c('v-img',{attrs:{"src":_vm.imageURL,"width":_vm.width}})],1)],1),(_vm.label=='true')?_c('td',[_vm._v(_vm._s(_vm.CutLength(_vm.profileName)))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }